import { render, staticRenderFns } from "./LogoutCallback.vue?vue&type=template&id=c093286a"
import script from "./LogoutCallback.vue?vue&type=script&lang=js"
export * from "./LogoutCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports